import { Fragment, useState, useMemo } from 'react';
import { useParams } from "react-router";
import { connect } from "react-redux";
import Loading from "components/Loading";
import { useTranslation } from "react-i18next";
import { ReactTableDataGrid } from "components/Table";
import useCallApi from "hook/useCallApi";
import { getProductsByShop, getProductTrend } from "actions/spyAdvancedActions";
import { heightRow } from "../../constant";
import useColumnTableProductsByShop from "../../hooks/useColumnTableProductsByShop";
import SpyFilter from "../../filter";

const limit = 20;

function Productlist({ products_filters, getProductsByShop, getProductTrend }) {
    const { t } = useTranslation();
    const { seller_id } = useParams();
    const [filter, setFilter] = useState({});
    const [page, setPage] = useState(1);
    const params = useMemo(() => ({ ...filter, page, per_page: limit, seller_id }), [filter, page, seller_id]);
    const { data, loading } = useCallApi(getProductsByShop, params);
    const productIds = useMemo(() => {
        return data?.data?.map((item) => item.product_id).join(",");
    }, [data]);
    const { data: productTrendData } = useCallApi(getProductTrend, productIds, Boolean(productIds));
    const columns = useColumnTableProductsByShop(heightRow, productTrendData, filter.dateRange);

    const onTableChanged = ({ page }) => {
        if (page) setPage(page);
    };

    return (
        <Fragment>
            <Loading isLoading={loading} />
            <div className="card mt-5 mb-5 mb-xl-10">
                <div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse" data-bs-target="#kt_account_profile_details" aria-expanded="true" aria-controls="kt_account_profile_details">
                    <div className="card-title m-0">
                        <h3 className="fw-bold m-0">{t("Product List")}</h3>
                    </div>
                </div>
                <div className="card-body">
                    <SpyFilter
                        filter={filter}
                        setFilter={(data) => {
                            setFilter(data);
                            setPage(1);
                        }}
                        filterProductCategory={products_filters?.product_categories}
                    />
                    <div className="mt-10">
                        <ReactTableDataGrid
                            tableName="productList"
                            idProperty="_id"
                            columns={columns}
                            rowData={data?.data || []}
                            pageNumber={page}
                            gridOptions={{
                                rowHeight: heightRow,
                                reactiveCustomComponents: true,
                            }}
                            paginationPageSize={limit}
                            totalSize={data?.meta?.total || 0}
                            emptyText={"No data!"}
                            isSearchText={false}
                            onTableChanged={onTableChanged}
                            height="calc(100vh - 300px)"
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

const mapStateToProps = state => ({
});
const mapDispatchToProps = {
    getProductsByShop,
    getProductTrend
}

export default connect(mapStateToProps, mapDispatchToProps)(Productlist);